// B241 FASE 2 (AI_109) — Rótulo/unidade dos campos de MARCADORES, para a
// TELA DE CONFERÊNCIA da importação por PDF (entrada única em Exames Lab).
//
// As CHAVES são as mesmas do backend (api/_lib/dicionarioMarcadores.js) e de
// `MarcadorAutoanticorpo`. Valores são TEXTO (tumorais numéricos; autoanticorpos
// qualitativos) → gravados como string, sem conversão numérica.

export interface RotuloCampo {
  label: string;
  unidade: string;
}

export const CAMPOS_MARCADORES_ROTULO: Record<string, RotuloCampo> = {
  // Tumorais
  afp: { label: "AFP (alfafetoproteína)", unidade: "ng/mL" },
  ca199: { label: "CA 19-9", unidade: "U/mL" },
  cea: { label: "CEA", unidade: "ng/mL" },
  ca125: { label: "CA 125", unidade: "U/mL" },
  psa: { label: "PSA total", unidade: "ng/mL" },
  // Metabolismo do ferro
  ferro: { label: "Ferro sérico", unidade: "µg/dL" },
  ferritina: { label: "Ferritina", unidade: "ng/mL" },
  saturacaoTransferrina: { label: "Saturação da transferrina", unidade: "%" },
  // Metabólicos / etiológicos
  cobreSerico: { label: "Cobre sérico", unidade: "µg/dL" },
  cobreUrinario: { label: "Cobre urinário (24h)", unidade: "µg/24h" },
  ceruloplasmina: { label: "Ceruloplasmina", unidade: "mg/dL" },
  alfa1Antitripsina: { label: "Alfa-1 antitripsina", unidade: "mg/dL" },
  // Função renal / urina 24h (B279 — AI_120)
  clearanceCreatinina: { label: "Clearance de creatinina (total)", unidade: "mL/min" },
  clearanceCreatininaCorrigido: {
    label: "Clearance de creatinina (corrigido 1,73m²)",
    unidade: "mL/min/1,73m²",
  },
  proteinuria24h: { label: "Proteinúria de 24h", unidade: "mg/24h" },
  // Sódio urinário / natriúria (AI_129) — amostra isolada e urina de 24h
  sodioUrinarioAmostra: {
    label: "Sódio urinário (amostra isolada)",
    unidade: "mEq/L",
  },
  sodioUrinario24h: { label: "Sódio urinário (24h)", unidade: "mEq/24h" },
  // Imunoglobulinas
  iggSerico: { label: "IgG sérica (total)", unidade: "mg/dL" },
  igg4: { label: "IgG4 (subclasse)", unidade: "mg/dL" },
  // Eletroforese de proteínas
  efpAlbumina: { label: "Albumina (eletroforese)", unidade: "g/dL" },
  efpAlfa1: { label: "Alfa-1 globulina (EFP)", unidade: "g/dL" },
  efpAlfa2: { label: "Alfa-2 globulina (EFP)", unidade: "g/dL" },
  efpBeta: { label: "Beta globulina (EFP)", unidade: "g/dL" },
  efpGama: { label: "Gamaglobulina (EFP)", unidade: "g/dL" },
  // Autoanticorpos (qualitativos)
  fan: { label: "FAN (fator antinuclear)", unidade: "" },
  antiLKM: { label: "Anti-LKM1", unidade: "" },
  antiMusculoLiso: { label: "Anti-músculo liso (ASMA)", unidade: "" },
  antiMitocondria: { label: "Anti-mitocôndria (AMA)", unidade: "" },
  anca: { label: "ANCA", unidade: "" },
  antiDNA: { label: "Anti-DNA nativo", unidade: "" },
  antiTransglutaminase: { label: "Anti-transglutaminase (anti-tTG)", unidade: "" },
};

export function rotuloCampoMarcador(campo: string): RotuloCampo {
  return CAMPOS_MARCADORES_ROTULO[campo] || { label: campo, unidade: "" };
}
